<template>
    <div class="main Ssdt">
        <Titledx text='部门事项图谱' />
        <div class="cont">
            <three />
        </div>
    </div>
</template>
<script>
import Titledx from "./components/title";
import miment from "miment";
import three from './third/Test1'
export default {
    components: {
        Titledx,
        three
    },
    data() {
        return {
        };
    },
    methods: {

        async getData() {
 
        }

        
    },
    created() {
        this.getData()
    },
    mounted() {
        // document.getElementsByClassName("Ssdt")[0].style.zoom = 0.5;
        // let huanjing = window.location.href.split("//")[1].split("/")[0];
        // console.log(huanjing);
        // window.btnclick = function (type) {
        //     if (type == "goback") {
        //         if (huanjing == "ct.shequyun.cn") {
        //             window.open(
        //                 "https://ceshi.shequyun.cn/#/moduleList",
        //                 "_self"
        //             );
        //         } else {
        //             window.open(`https://${huanjing}/#/moduleList`, "_self");
        //         }
        //     }
        // };
    },
};
</script>
<style lang="less" scoped>
.main {
    overflow: hidden;
    .cont {
        height: 850px;
        margin-left: 20px;
        box-sizing: border-box;
        padding: 30px 40px;
        text-align: center;
        .source {
            width: 158px;
        }
        .eventTitle {
            width: 760px;
        }
        .time,
        .department,
        .status {
            width: 142px;
        }
        .source,
        .eventTitle,
        .time,
        .department,
        .status {
            margin: 0 20px 
        }
        .title {
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #18d0ff;
            width: 100%;
            background: rgba(29, 53, 97, 1);
            display: flex;
            align-items: center;
            justify-content: space-around;
            height: 64px;
            margin-bottom: 20px;
        }
        .info {
            .swiper-slide /deep/ {
                height: 48px !important;
                margin: 10px 0;
            }
            height: 810px;
            .box {
                width: 100%;
                height: 100%;
                color: #fff;
                font-size: 20px;
                background: rgba(29, 53, 97, 1);
                align-items: center;
                justify-content: space-around;
                span {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .source{
                    font-size: 20px;
                }  
                .eventTitle {
                    font-size: 20px;
                    color: rgba(255, 217, 4, 1);
                }
                .time,
                .department,
                .status {
                    font-size: 16px;
                }
                .doing {
                    color:rgba(255, 168, 0, 1)
                }
                .done {
                    color:rgba(0, 255, 42, 1)
                }
                .source,
                .eventTitle,
                .time,
                .department,
                .status {
                    background: rgba(43, 71, 121, 1);
                    margin: 0 20px
                }
            }
        }
    }
}
</style>